import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import styles from "./InvoiceDetails.module.scss";
import CustomInputField from "../../../../CustomHTMLElements/CustomInputField";
import { ILoanInformation } from "../LoanInformation/util";
import moment from "moment";

const InvoiceDetails = ({ data, refetchData }: ILoanInformation) => {
  const { register, setValue } = useForm();
  const currentClient =
    data?.data?.data?.loan_application_details[0]?.invoice_detail
      ?.principal_name;
  const activeContractBuyer =
    data?.data?.data?.loan_application_details[0]?.invoice_detail
      ?.has_contract_with_buyer;
  const currency = data?.data?.data?.loan_application_details[0]?.currency;
  const valueofInvoiceToBeDiscounted =
    data?.data?.data?.loan_application_details[0]?.invoice_detail
      ?.invoice_amount;
  const invoiceNumber =
    data?.data?.data?.loan_application_details[0]?.invoice_detail
      ?.invoice_number;
  const purchaseOrderNumber =
    data?.data?.data?.loan_application_details[0]?.invoice_detail
      ?.purchase_order_number;
  const loanAmount =
    data?.data?.data?.loan_application_details[0]?.approved_amount;
  const loanProduct =
    data?.data?.data?.loan_application_details[0]?.approved_loan_product_detail;

  const dueDateForPaymentOfInvoiceToBeDiscounted = data?.data?.data
    ?.loan_application_details[0]?.invoice_detail?.due_date
    ? moment(
        data?.data?.data?.loan_application_details[0]?.invoice_detail?.due_date,
      ).format("YYYY-MM-DD")
    : "";

  const advancePaymentByAnchorCorporate =
    data?.data?.data?.loan_application_details[0]?.invoice_detail
      ?.advance_payment_amount > 0
      ? data?.data?.data?.loan_application_details[0]?.invoice_detail
          ?.advance_payment_amount
      : "";

  useEffect(() => {
    if (data?.data?.data?.loan_application_details.length > 0) {
      setValue("client", currentClient);
      setValue("activeContractBuyer", activeContractBuyer);
      setValue("currency", currency);

      setValue(
        "valueofInvoiceToBeDiscounted",
        valueofInvoiceToBeDiscounted
          ? Number(valueofInvoiceToBeDiscounted).toLocaleString("en-US")
          : null,
      );

      setValue("invoiceNumber", invoiceNumber);
      setValue("purchaseOrderNumber", purchaseOrderNumber);

      setValue(
        "loanAmount",
        loanAmount ? Number(loanAmount).toLocaleString("en-US") : null,
      );
      setValue("loanProduct", loanProduct);

      setValue(
        "dueDateForPaymentOfInvoiceToBeDiscounted",
        dueDateForPaymentOfInvoiceToBeDiscounted,
      );
      setValue(
        "advancePaymentByAnchorCorporate",
        advancePaymentByAnchorCorporate
          ? Number(advancePaymentByAnchorCorporate).toLocaleString("en-US")
          : null,
      );
    }
  }, []);

  return (
    <div className={styles.invoiceDetailsContainer}>
      <form>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="client"
              label="Client(Principal)"
              reference={register}
              labelClass="label-txt form-label d-flex justify-content-between"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="activeContractBuyer"
              label="Do You Have An Active Contract With The Buyer? *"
              reference={register}
              labelClass="label-txt form-label d-flex justify-content-between"
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="currency"
              type="text"
              label="Currency"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="valueofInvoiceToBeDiscounted"
              type="text"
              label="Value Of Invoice To Be Discounted"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="invoiceNumber"
              type="text"
              label="Invoice Number"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="purchaseOrderNumber"
              type="text"
              label="Purchase Order Number"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="loanAmount"
              type="text"
              label="Loan Amount "
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="loanProduct"
              label="Loan Product"
              reference={register}
              labelClass="label-txt form-label d-flex justify-content-between"
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="dueDateForPaymentOfInvoiceToBeDiscounted"
              type="date"
              label="Due Date For Payment Of Invoice To Be Discounted"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="advancePaymentByAnchorCorporate"
              type="text"
              label="Advance payment by Anchor Corporate(Optional)"
              reference={register}
              value={
                data?.data?.data?.loan_application_details.length > 0
                  ? data?.data?.data?.loan_application_details[0]
                      ?.invoice_detail?.invoice_number
                  : ""
              }
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default InvoiceDetails;
